// extracted by mini-css-extract-plugin
module.exports = {"box":"shareLink_box__35HYm","input":"shareLink_input__2cHxr","input_box":"shareLink_input_box__15tC7"};